// Import services for the dataService object
import { contractService } from './contractService';
import { lawFirmService } from './lawFirmService';
import { legalResearchService } from './legalResearchService';
import { profileService } from './profileService';
import { userService } from './userService';

// Main data service that exports all individual services
export {
  type ClausePresent,
  type ComplianceWarning,
  type ConflictingClause,
  type ContractOverview,
  type ContractReviewDatabaseResult,
  type ContractReviewRequest,
  type ContractReviewResult,
  contractService,
  type DraftingQuality,
  type FavorabilityAssessment,
  getContractReviewDisplayName,
  type KeyTerms,
  type MarketDeviation,
  type MissingClause,
  normalizeContractReviewResult,
  type OverallAssessment,
  type RedFlag,
} from './contractService';
export { type LawFirm, lawFirmService } from './lawFirmService';
export {
  type CaseCitation,
  type CaseSummary,
  type KeyParagraph,
  type LegalResearchDatabaseResult,
  type LegalResearchRequest,
  type LegalResearchResult,
  legalResearchService,
  type Recommendation,
  type ResearchProgress,
  type StatutoryMaterial,
  type StatutorySection,
} from './legalResearchService';
export { type Profile, profileService } from './profileService';
export { userService } from './userService';

// Export all services as a single object for easier imports
export const dataService = {
  profile: profileService,
  legalResearch: legalResearchService,
  user: userService,
  lawFirm: lawFirmService,
  contract: contractService,
};
